import cookie from 'react-cookies'

export function buildFallbackProfile() {
  return {
    name: cookie.load('user_name') || '',
    email: cookie.load('user_email') || '',
    phone: '',
    business: cookie.load('business_name') || ''
  }
}

export function getMyProfileActiveTab(pathname) {
  return pathname === '/perfil/seguridad' ? 'seguridad' : 'informacion'
}

export function buildMyProfileActionAlert(message, severity = 'success') {
  return {
    id: Date.now(),
    severity,
    message
  }
}
